import { DatePicker } from "antd";
import React from "react";
import dayjs from "dayjs";
import PropTypes from "prop-types";
import { useUpdatePaymentDateMutation } from "AppQuries/payroll/staging";
import Swal from "sweetalert2";
import { toast } from "core/Operations/toast";
import { format } from "date-fns";
import { useUpdatePaymodeMutation } from "AppQuries/master/Paymode/pay-mode";
import { updatePaymentDateValidation } from "core/Operations/ValidationSchema/payrollValidation";

const StagingPayDate = ({
  name,
  placeholder,
  dateFormat,
  record,
  index,
  setReportData,
}) => {
  const { mutateAsync: updatePaymentDate } = useUpdatePaymentDateMutation();
  const updatePayDate = async (date, record) => {
    console.log("Ref No:", record?.refNo);
    const payload = {
      companyCode: record?.companyCode,
      paymentDate: (date && format(new Date(date), "yyyy-MM-dd")) || "",
      refNo: [record?.refNo],
    };

    try {
      await updatePaymentDateValidation.validate(payload);
    } catch (err) {
      Swal.fire({
        title: "Warning!",
        text: err?.message || "Validation error. Please check your input.",
        type: "warning",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Ok",
        confirmButtonClass: "btn btn-primary",
        okButtonClass: "",
        buttonsStyling: 1,
      });
      return;
    }

    updatePaymentDate(payload, {
      onSuccess: (response) => {
        if (response?.response === true) {
          toast.success("Payment Date Updated!");
          setReportData((prev) =>
            prev.map((item, i) =>
              i === index
                ? {
                    ...item,
                    paymentDate: date ? dayjs(date).format(dateFormat) : "",
                  }
                : item,
            ),
          );
        } else {
          toast.error(
            response?.errorMessage || "Failed to update payment date.",
          );
        }
        //   Swal.fire({
        //     type: "success",
        //     title: "Payement Date Updated!",
        //     text: response?.errorMessage,
        //     confirmButtonClass: "btn btn-success",
        //   }).then(function (t) {
        //     // navigate(`${all_routes.payroll}${all_routes.payroll_stage}`);
        //     handleRefresh();
        //   });
        // } else {
        //   Swal.fire({
        //     title: "Warning!",
        //     text: response?.errorMessage,
        //     type: "warning",
        //     confirmButtonColor: "#3085d6",
        //     confirmButtonText: "Ok",
        //     confirmButtonClass: "btn btn-primary",
        //     okButtonClass: "",
        //     buttonsStyling: 1,
        //   });
        // }
      },
    });

    // updatePaymentDate(payload)
    //   .then((response) => {
    //     if (response?.response === true) {
    //       setReportData((prev) =>
    //         prev.map((item, i) =>
    //           i === index
    //             ? {
    //                 ...item,
    //                 paymentDate: date ? dayjs(date).format(dateFormat) : "",
    //               }
    //             : item,
    //         ),
    //       );
    //     } else {
    //       Swal.fire({
    //         title: "Warning!",
    //         text: response?.errorMessage,
    //         type: "warning",
    //         confirmButtonColor: "#3085d6",
    //         confirmButtonText: "Ok",
    //         confirmButtonClass: "btn btn-primary",
    //         okButtonClass: "",
    //         buttonsStyling: 1,
    //       });
    //     }
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //   });
  };

  return (
    <DatePicker
      name={name}
      placeholder={placeholder}
      format={dateFormat}
      className="form-control"
      style={{ width: "100%" }}
      allowClear={false}
      value={
        record?.paymentDate ? dayjs(record.paymentDate, dateFormat) : dayjs()
      }
      onChange={(date, dateString) => updatePayDate(dateString, record, index)}
    />
  );
};

StagingPayDate.propTypes = {
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  dateFormat: PropTypes.string.isRequired,
  record: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  setReportData: PropTypes.func.isRequired,
};

export default StagingPayDate;
